export default __webpack_public_path__ + "static/media/quote-block-thumbnail-dark.913db213.svg";